import React from 'react';
import IPage from '../../interfaces/page'
import { Desktop, MobileOrTablet } from '../media-queries';
import DesktopHomePage from './desktop';
import MobileHomePage from './mobile';

const HomePage: React.FunctionComponent<IPage> = () => {
    const CLASS_NAME = "home-page";

    return <div className={CLASS_NAME}>
        <Desktop>
            <DesktopHomePage />
        </Desktop>
        <MobileOrTablet>
            <MobileHomePage />
        </MobileOrTablet>
    </div>
}

export default HomePage